import { render, staticRenderFns } from "./ExportLogs.vue?vue&type=template&id=71869c50"
import script from "./ExportLogs.vue?vue&type=script&lang=js"
export * from "./ExportLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports